import React from "react";

import { Row, Container } from "reactstrap";

function DemoFooter() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          <nav className="footer-nav">
            <ul>
              <li>
                <a
                  href="https://apurasul.com.br"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Apurasul Perícias e Investigações Contábeis
                </a>
              </li>
            </ul>
          </nav>
          <div className="credits ml-auto">
            <span className="copyright">
              Copyright © {new Date().getFullYear()} Todos os direitos reservados.  
              <a href='https://mootec.com.br/' target="_blank">
              &nbsp;&nbsp;&nbsp;MooTec Technology in Business
              </a>
            </span>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default DemoFooter;
